var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"animate-rotate",class:{rotate_inner: _vm.rotate},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 0 10 6","fill":"none"}},[_c('path',{attrs:{"d":"M1 1L5 5L9 1","stroke":_vm.fill,"stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }